// extracted by mini-css-extract-plugin
export default {"notification-bar":"jQb3Y","additionalInfo":"rVYqR"};